import { StoreSpecialFont } from '@/types';
import { fetchSpecialFonts } from '@/utils/http/fetchSpecialFonts';
import { mapSpecialFont } from '@/model/font/mapSpecialFont';
import { Thunk } from '@/redux/types';
import { CoreActionTypes, SpecialFontsFetchAction } from '../types';

export const fetchSpecialFontsAction =
  (): Thunk<Promise<void>, SpecialFontsFetchAction> => (dispatch) =>
    fetchSpecialFonts()
      .then((fonts) => {
        const payload: StoreSpecialFont[] = fonts.map(mapSpecialFont);
        dispatch({ type: CoreActionTypes.SPECIAL_FONTS_FETCH, payload });
      })
      .catch(() => {
        // ignore
      });
